/* eslint-disable import/prefer-default-export */
import { useFeatureFlags } from 'hooks/usePageConfig'

export const useBooleanVariationFromFeatureFlag = (key: string) => {
  const featureFlags = useFeatureFlags()
  return featureFlags?.[key]?.value === true
}
